import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { HttpEventType, HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';
import { DocumentService } from 'src/app/_services/document.services';
import { MatTableDataSource } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UsersAndGroupsService } from 'src/app/_services/users-and-groups.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { User } from 'src/app/_models';
import { AppConfig } from 'src/assets/config/config/app-config';
import { DatePipe, formatDate } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import { FileInboxVirtualFolderService } from 'src/app/_services/fileInbox-virtualFolder.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { error } from 'console';



@Component({
  selector: 'app-dialog-index-migrate',
  templateUrl: './dialog-index-migrate.component.html',
  styleUrls: ['./dialog-index-migrate.component.scss']
})
export class DialogIndexMigrateComponent implements OnInit {
 
  width = '100';
  message = '';
  fileUploaded: boolean = false;
  docsList: MatTableDataSource<any>;
  documentCols = ["File Name", "Size"]
  deactivateUpload: boolean = false;
  fileLoading: boolean = false
  uploadFiles: any;
  recordIndexes = [];

  constructor(
    public dialogRef: MatDialogRef<DialogIndexMigrateComponent>,
    private documentService: DocumentService,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.uploadFiles = data['uploadFileList'];   
  }

  ngOnInit() {
    var today = this.datePipe.transform(new Date(), 'MM/dd/yyyy');
    this.uploadFiles.forEach((element, index) => {
        let properties = {};
        element['objValues'].forEach(property => {
          if (property.name != 'Document Title' && property.name != 'Document ID' && property.name != 'Creation Date' && property.name != 'Created By' && property.name != 'Modified Date' && property.name != 'Modified By' && property.name != 'Size' && property.name != 'PAP Metadata' && property.name != 'Portal User Info' && property.name != 'Digitization User Info' && property.name != 'Security Groups' && property.name != 'Version' && property.name != 'Batch ID' && property.name != 'ImageTrust Document ID' && property.name != 'Document Source' && property.name != 'File Type' && property.name != 'Reference Entities') {
            if (property.data_type === "date") {
              if (property.visible) {
                if (property.value) {
                  const editField = new Date(property.value);          
                  let dateString = this.datePipe.transform(editField, 'MM/dd/yyyy');
                  property.value = dateString;
                  properties[property.name] = dateString;                
                } else{
                  properties[property.name] = property.value;
                }
              } else {
                if (property.value && property.value != "") {
                  const editField = new Date(property.value);          
                  let dateString = this.datePipe.transform(editField, 'MM/dd/yyyy');
                  property.value = dateString;
                  properties[property.name] = dateString;
                }
              }
            }
            else if (property.data_type === "int") {
              if (property.visible) {
                property.value = parseInt(property.value);
                properties[property.name] = parseInt(property.value);
              }
            }
            else if (property.data_type == "bool") {
              if (property.visible) {
                properties[property.name] = property.value
                if (property.value !== true) {
                  property.value = false;
                  properties[property.name] = false;
                }
              } else {
                if (property.name == "Public Search") {
                  properties[property.name] = false;
                }
              }
            }
            else if (property.name == 'Water Right ID') {
              let wrIds = [];
              if (property.value) {
                let wrList = property.value.split(",");
                for (var index in wrList) {
                  wrIds.push(wrList[index].trim());
                }
              }
              if (wrIds.length > 0) {
                properties[property.name] = wrIds;
              }
            }
            else {
              if (property.value && property.value != "") {
                properties[property.name] = property.value;
              }        
            }
          }
        });
        properties["Portal User Info"] = {
          reviewedBy: ""
        };
        properties["Source"] = "Legacy Migration";
        var systemProperties = {
          "fileName": element.name,
          "lastModifiedDate": today,
          "size": element.system.size,
          "type": element.system.type
        }
        var recordIndex = {
          "docId": element.document_id,
          "title": element.name,
          "meta_data": properties,
          "system_properties": systemProperties
        }
        this.recordIndexes.push({ value: 0, recordIndex: recordIndex, fileName: element.name, size: element.system.size });    
      });
    this.docsList = new MatTableDataSource(this.recordIndexes);  
    this.uploadCaptureDocument();
  }

  close() {
    this.dialogRef.close()
  }

  async uploadCaptureDocument() {
   
    this.fileUploaded = false;
    for (let i = 0; i < this.recordIndexes.length; i++) {     
      await this.makeUploadServiceCall(this.recordIndexes[i].recordIndex, i);
    }
  }

  makeUploadServiceCall(recordIndex, i) {
    return new Promise((resolve, reject) => {
      let records = [];
      records.push(recordIndex);
      var request = {
        "recordsIndex": records        
      }
      this.documentService.indexDocumentMetadata(request)
        .subscribe( resp => {
          if (resp && resp == 'Document migration completed') {
            this.recordIndexes[i].value = 100;
            this.fileUploaded = true;
            
            // Check if Water Right ID exists and is valid, then update water right reference
            const waterRightId = recordIndex.meta_data['Water Right ID'];
            if (waterRightId && Array.isArray(waterRightId) && waterRightId.length > 0) {
              this.documentService.updateWaterRightReference(recordIndex.docId)
                .subscribe(
                  updateResp => {
                    console.log('Water Right reference updated successfully for document:', recordIndex.docId);
                  },
                  updateError => {
                    console.error('Failed to update Water Right reference for document:', recordIndex.docId, updateError);
                  }
                );
            }
            
            if (this.recordIndexes.length === i + 1) {
              this.dialogRef.close(this.fileUploaded);
            }
            resolve("Migrated successfully");
          } else{
            this.recordIndexes[i].value = 0;
            this.message = 'Could not upload the file:' + this.recordIndexes[i].fileName;
            reject("Migrated failed");
          }
        });
      });
  }

  onClose(): void {
    this.dialogRef.close(this.fileUploaded);
  }

}
